import { Observable } from 'rxjs';

import { ChecklistConditionsCreateParams, ChecklistCreateParams, ChecklistItemsCreateParams, Checklists } from '../models/checklist.model';

export abstract class ChecklistUsecase {
  abstract get checklists$(): Observable<Checklists>;

  abstract createChecklist(params: ChecklistCreateParams): Observable<string>;
  abstract deleteChecklist(checklistId: string): Observable<never>;
  abstract createChecklistFlowchart(checklistId: string, flowchart: string): Observable<never>;
  abstract createChecklistItems(checklistId: string, params: ChecklistItemsCreateParams): Observable<never>;
  abstract createChecklistConditions(checklistId: string, params: ChecklistConditionsCreateParams): Observable<never>;
}
